import React, { useCallback, useState } from 'react';
import { Input, Popover } from 'antd';
import clsx from 'clsx';
import UserAvatar from 'shared/components/UserAvatar';
import { Icon } from 'shared/components/Icon';
import { Button } from '../Button';
import { useOrgMemberSearch } from 'shared/hooks/search';
import './style.less';

interface BulkConversationAssignButtonProps {
  isDisabled?: boolean;
  handleBulkAssign: (assigneeId: number) => Promise<string[]>;
  callback?: () => void;
}

export const BulkConversationAssignButton: React.FC<BulkConversationAssignButtonProps> = ({
  isDisabled,
  handleBulkAssign,
  callback,
}) => {
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);
  const { filteredMembers, search, setSearch } = useOrgMemberSearch();

  const handleAssign = useCallback(
    async (assigneeId: number) => {
      setIsPopoverVisible(false);
      try {
        await handleBulkAssign(assigneeId);
        if (callback) {
          callback();
        }
      } catch {
        /* no-op */
      }
    },
    [callback, handleBulkAssign],
  );

  return (
    <Popover
      visible={isPopoverVisible}
      onVisibleChange={() => setIsPopoverVisible(false)}
      placement="bottomRight"
      overlayClassName="BulkConversationAssignButton__overlay"
      content={
        <div
          className="BulkConversationAssignButton"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <div className="BulkConversationAssignButton__title">Assignee</div>
          <div className="BulkConversationAssignButton__search">
            <Input
              allowClear
              type="search"
              placeholder="Search..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              prefix={
                <Icon
                  icon="search"
                  className="BulkConversationAssignButton__search-icon"
                />
              }
            />
          </div>
          <div className="BulkConversationAssignButton__members">
            {filteredMembers.map(m => {
              return (
                <button
                  key={m.id}
                  className={clsx('BulkConversationAssignButton__member')}
                  onClick={() => handleAssign(m.id)}
                >
                  <UserAvatar
                    className="BulkConversationAssignButton__member-avatar"
                    user={m}
                    size={32}
                  />
                  <div className="BulkConversationAssignButton__member-name">
                    {m.displayName}
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      }
    >
      <Button
        type="ghost"
        className="ConversationList__bulkActions-assign"
        icon={<Icon icon="refresh" />}
        disabled={isDisabled}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          setIsPopoverVisible(!isPopoverVisible);
        }}
      >
        Assign
      </Button>
    </Popover>
  );
};
